import React, { useState } from 'react';
import styled from 'styled-components';
// Sidebar temporarily hidden (commented out per request)
// import Sidebar from './Sidebar';
import Header from './Header';

const AppContainer = styled.div`
  display: flex;
  height: 100vh;
  background: var(--background);
  color: var(--text-primary);
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const MainContent = styled.main`
  flex: 1;
  overflow-x: hidden;
  background: #ffffff;
  height:100%
`;

const Layout = ({ children }) => {
  // Default collapsed per UX request
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };
  
  return (
    <AppContainer>
      {/* Sidebar hidden — uncomment to restore */}
      {/** <Sidebar collapsed={sidebarCollapsed} /> */}
      <ContentWrapper>
        <Header toggleSidebar={toggleSidebar} isSidebarCollapsed={sidebarCollapsed} />
        <MainContent>{children}</MainContent>
      </ContentWrapper>
    </AppContainer>
  );
};

export default Layout;
